import React from 'react';

const InvestorDashboard = ({ activeTab = 'portfolio' }) => {
  return (
    <div style={{ padding: '24px' }}>
      <h1>Investor Dashboard</h1>
      <p>Active Tab: {activeTab}</p>
      <p>Investment features coming soon...</p>
    </div>
  );
};

export default InvestorDashboard;
